import { api } from '../configs/axiosConfigs';

export const getListUploads = async () => {
  return await api('/list-uploads.json');
};
